@if (loading()) {
  <div class="flex flex-col gap-4" data-testid="recent-activity-loading">
    @for (placeholder of [1, 2, 3]; track placeholder) {
      <xemex-skeleton-block width="100%" height="40px" />
    }
  </div>
} @else if (failed()) {
  <p class="m-0 py-6 text-center text-text-secondary" data-testid="recent-activity-failed">
    {{ 'installations.activity.loadFailed' | translate }}
  </p>
} @else if (rows().length) {
  <ul class="m-0 flex list-none flex-col divide-y divide-border-default p-0">
    @for (row of rows(); track row.key) {
      <li
        class="flex items-start gap-3 py-3 first:pt-0 last:pb-0"
        data-testid="recent-activity-row"
      >
        <span class="recent-activity__icon">
          <mat-icon fontSet="material-icons-outlined">{{ row.icon }}</mat-icon>
        </span>
        <div class="flex min-w-0 flex-1 flex-wrap items-start gap-x-3 gap-y-1">
          <div class="recent-activity__content">
            <div class="flex flex-wrap items-center gap-2">
              <span class="font-semibold text-text-default">{{ row.action }}</span>
              @if (row.showStatus) {
                <xemex-tag [state]="row.statusState" [label]="row.status" />
              }
            </div>
            @if (row.detail) {
              <div class="truncate text-sm text-text-secondary" [title]="row.detail">
                {{ row.detail }}
              </div>
            }
          </div>
          <div class="ml-auto flex-none text-right">
            <div class="font-semibold text-text-default">{{ row.initiatedOn }}</div>
            <div class="text-sm text-text-secondary">{{ row.initiatedBy }}</div>
          </div>
        </div>
      </li>
    }
  </ul>
} @else {
  <div class="py-6 text-center text-text-secondary" data-testid="activity-empty">
    <xemex-installation-activity-empty [devices]="devices()" />
  </div>
}
